import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7e18aba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AEtapas__lista" }
const _hoisted_2 = ["disabled", "onClick"]
const _hoisted_3 = { class: "AEtapas__numero" }
const _hoisted_4 = { class: "AEtapas__titulo" }
const _hoisted_5 = {
  key: 0,
  class: "AEtapas__separador"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "AEtapas__separador__linha" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { computed } from "vue"
import { Etapa } from "./AEtapas.modelos"

interface Props {
  etapas: Etapa[]
  indiceAtivo: number
  clicavel?: boolean
  largura?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AEtapas',
  props: {
    etapas: null,
    indiceAtivo: null,
    clicavel: { type: Boolean, default: true },
    largura: { default: "100%" }
  },
  emits: ["etapa-clicada"],
  setup(__props: any, { emit: emitir }: { emit: ({
  (event: "etapa-clicada", indice: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { etapas: Etapa[], indiceAtivo: number, clicavel: boolean, largura: string }





const estiloContainer = computed(() => ({
  width: props.largura,
}))

const aoClicarNaEtapa = (indice: number) => {
  if (props.clicavel && indice !== props.indiceAtivo) {
    emitir("etapa-clicada", indice)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["AEtapas", { 'AEtapas--clicavel': !__props.clicavel }]),
    style: _normalizeStyle(_unref(estiloContainer))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.etapas, (etapa, indice) => {
        return (_openBlock(), _createElementBlock("div", {
          key: indice,
          class: _normalizeClass(["AEtapas__item", {
          'AEtapas__item--reduzido': indice === __props.etapas.length - 1,
          'AEtapas__item--ativo': indice === __props.indiceAtivo,
          'AEtapas__item--clicavel': __props.clicavel && indice !== __props.indiceAtivo,
        }])
        }, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["AEtapas__botao", { 'AEtapas__botao--clicavel': __props.clicavel && indice !== __props.indiceAtivo }]),
            disabled: indice === __props.indiceAtivo,
            onClick: ($event: any) => (aoClicarNaEtapa(indice))
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(indice + 1), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(etapa.rotulo), 1)
          ], 10, _hoisted_2),
          (indice < __props.etapas.length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true)
        ], 2))
      }), 128))
    ])
  ], 6))
}
}

})